import { Http } from "../utils/http.js";

export class LoginService {
  login(username, password) {
    var url = "/authentication/login";
    var postData = {
      username: username,
      password: password,
      source: process.env.REACT_APP_SOURCE,
    };

    return new Http().post(url, postData);
  }

  protected() {
    return new Http().post("/authentication/protected", "");
  }

  logout() {
    var postData = {
      username: "",
      password: "",
      source: "",
    };
    return new Http().post("/authentication/logout", postData);
  }
}
